// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Setup__optionsContainerFields___tmg8t {
    display: flex;
    align-items: center;
    padding-bottom: 0.8rem;
}

.Setup__containerFieldsPadding___EOlKi {
    padding-bottom: 1.6rem;
}

.Setup__coordinatesCombobox___c7rgP {
    padding-right: 0.8rem;
}

.Setup__containerFields___Mmbom .Setup__coordinatesCombobox___c7rgP {
    width: 29%;
}

.Setup__containerFields___Mmbom .Setup__coordinatesSelect___ZZnOo {
    width: 49%;
}

.Setup__optionsContainer___OU_c2 .Setup__optionsFormField___AKJE6 {
    width: 55%;
}

.Setup__setupScroll___aUWBR {
    overflow: auto;
    padding-left: 1.2rem;
}

.Setup__headerMargin___L9SgD {
    margin-bottom: 0.8rem;
}

.Setup__surveyWrapper___Jvlgh {
    display: flex;
    flex-direction: column;
    padding-bottom: 2.4rem;
}

@media screen and (width >=112rem) {
    .Setup__setupDirection___aWnuZ {
        flex-direction: row;
    }

    .Setup__setupAutoScroll___QG6vv {
        overflow: auto;
    }

    .Setup__setupWidth___J9YY0 {
        width: 50%;
    }

    .Setup__setupPadding___K6oDM {
        padding-right: 1.2rem;
    }
}

@media screen and (width < 112rem) {
    .Setup__setupDirection___aWnuZ {
        flex-direction: column;
    }

    .Setup__setupPadding___K6oDM {
        padding-top: 4rem;
    }
}

.Setup__setupDirection___aWnuZ {
    display: flex;
    padding-top: 2.4rem;
}

.Setup__codeFrame___qXg8r {
    overflow: auto;
    display: flex;
    flex-grow: 1;
    gap: 3.2rem;

    height: 7.35rem;

    border: 0.1rem solid var(--color-bg-border);
    border-radius: 0.4rem;
}

.Setup__codeFrameTextHeader___kdnpL {
    padding: 1.6rem;
}

.Setup__codeFrameTextHeaderIndex___tn7QO {
    width: 5.2rem;
    line-height: 1.6rem;
}

.Setup__codeFrameTextHeaderText___Uq0_d {
    line-height: 1.6rem;
    white-space: nowrap;
}

.Setup__codeFrameBinaryHeader___rcKSV,
.Setup__codeFrameTraceHeaders___UTw5y {
    width: 100%;
}

.Setup__choiceGroupHeaders___HSn1E {
    display: grid;
    grid-template-columns: 33% auto 33% auto 33%;
}

/* stylelint-disable selector-class-pattern -- класс Consta */
.Setup__codeFrameBinaryHeader___rcKSV.Table .Table-ContentCell,
.Setup__codeFrameTraceHeaders___UTw5y.Table .Table-ContentCell {
    font-size: var(--size-text-xs);
    line-height: var(--line-height-text-l);
}
/* stylelint-enable selector-class-pattern */

/* stylelint-disable-next-line selector-class-pattern -- класс Consta */
.Setup__codeFrameTextHeader___kdnpL .Table-ContentCell {
    line-height: var(--line-height-text-l);
}

.Setup__radioLabel___s3kqT {
    padding-bottom: 0.8rem;
}

/* stylelint-disable-next-line selector-class-pattern -- класс Consta */
.Setup__radioLabel___s3kqT .Radio-Label {
    font-size: var(--size-text-s);
}

/* stylelint-disable-next-line selector-class-pattern -- класс Consta */
.Setup__checkboxLabel___ktVi4 .Checkbox-Label {
    font-size: var(--size-text-s);
}

.Setup__fullWidth___iXyeE {
    width: 100%;
}

.Setup__halfWidth___LD9wX {
    width: 50%;
}

.Setup__containerFields___Mmbom {
    display: flex;
    justify-content: flex-end;
    width: 100%;
}

.Setup__flexedColumn___uYdHe {
    display: flex;
    flex-direction: column;
}

.Setup__codeBinaryHeaderTable___t5D3Q {
    flex-direction: column;
    flex-grow: 1;
}

.Setup__typeChoiceContainer___vBSGP {
    display: flex;
    padding-top: 3.2rem;
}

.Setup__typeChoiceWrapper___Fd2Xs {
    padding-right: 1.6rem;
}

.Setup__textPadding___kNkjP {
    padding-bottom: 0.8rem;
}

.Setup__checkboxWrapper___DT6u0 {
    display: flex;
    flex-direction: column;
    margin-top: 3.2rem;
}

.Setup__ignoreSegy____RQeC {
    padding-bottom: 0.8rem;
}

.Setup__ignoreZeros___RaJPU {
    padding-bottom: 2.4rem;
}

.Setup__coordinatesWrapper___eT9jQ {
    display: flex;
}

.Setup__coordinatesLabel___NAlXS {
    margin-bottom: 1.6rem;
    padding-right: 0.8rem;
}

.Setup__coordinatesBtn___a36Yn {
    margin-right: 0.8rem;
}

.Setup__coordinatesList___xIr3I {
    display: flex;
    flex-direction: column;
}

.Setup__coordinatesNameText___E6zbC {
    padding-right: 1.2rem;
}

.Setup__formatText___G2JxL {
    margin-top: 2.8rem;
    margin-bottom: 0.8rem;
}

.Setup__formatSelect___r25EG {
    padding-bottom: 2.4rem;
}

.Setup__optionsWrapper___FVfB7 {
    display: flex;
    flex-direction: column;
}

.Setup__importWrapper___raIkE {
    flex-grow: 1;
    padding-left: 1.2rem;
}

.Setup__importText___maKFr {
    padding-bottom: 0.8rem;
}

.Setup__optionsContainer___OU_c2 {
    display: flex;
    align-items: center;
    justify-content: flex-end;

    width: 100%;
    padding-bottom: 0.8rem;
}

.Setup__optionIcon___D3R_X {
    margin-right: 0.8rem;
}

.Setup__optionsLabel___pmu3P {
    padding-right: 0.8rem;
}

.Setup__codeFrameTextWrapper___mCGGB {
    display: flex;
    gap: var(--space-xs);
    align-items: center;
}

.Setup__coordinatesPadding___mAkAk {
    padding-bottom: 0.8rem;
}
`, "",{"version":3,"sources":["webpack://./src/core/pages/Project/MasterImport/SegyImport/Setup/Setup.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI;QACI,mBAAmB;IACvB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,qBAAqB;IACzB;AACJ;;AAEA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,YAAY;IACZ,WAAW;;IAEX,eAAe;;IAEf,2CAA2C;IAC3C,qBAAqB;AACzB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;;IAEI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,4CAA4C;AAChD;;AAEA,6DAA6D;AAC7D;;IAEI,8BAA8B;IAC9B,sCAAsC;AAC1C;AACA,4CAA4C;;AAE5C,uEAAuE;AACvE;IACI,sCAAsC;AAC1C;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,uEAAuE;AACvE;IACI,6BAA6B;AACjC;;AAEA,uEAAuE;AACvE;IACI,6BAA6B;AACjC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;;IAEzB,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B","sourcesContent":[".optionsContainerFields {\n    display: flex;\n    align-items: center;\n    padding-bottom: 0.8rem;\n}\n\n.containerFieldsPadding {\n    padding-bottom: 1.6rem;\n}\n\n.coordinatesCombobox {\n    padding-right: 0.8rem;\n}\n\n.containerFields .coordinatesCombobox {\n    width: 29%;\n}\n\n.containerFields .coordinatesSelect {\n    width: 49%;\n}\n\n.optionsContainer .optionsFormField {\n    width: 55%;\n}\n\n.setupScroll {\n    overflow: auto;\n    padding-left: 1.2rem;\n}\n\n.headerMargin {\n    margin-bottom: 0.8rem;\n}\n\n.surveyWrapper {\n    display: flex;\n    flex-direction: column;\n    padding-bottom: 2.4rem;\n}\n\n@media screen and (width >=112rem) {\n    .setupDirection {\n        flex-direction: row;\n    }\n\n    .setupAutoScroll {\n        overflow: auto;\n    }\n\n    .setupWidth {\n        width: 50%;\n    }\n\n    .setupPadding {\n        padding-right: 1.2rem;\n    }\n}\n\n@media screen and (width < 112rem) {\n    .setupDirection {\n        flex-direction: column;\n    }\n\n    .setupPadding {\n        padding-top: 4rem;\n    }\n}\n\n.setupDirection {\n    display: flex;\n    padding-top: 2.4rem;\n}\n\n.codeFrame {\n    overflow: auto;\n    display: flex;\n    flex-grow: 1;\n    gap: 3.2rem;\n\n    height: 7.35rem;\n\n    border: 0.1rem solid var(--color-bg-border);\n    border-radius: 0.4rem;\n}\n\n.codeFrameTextHeader {\n    padding: 1.6rem;\n}\n\n.codeFrameTextHeaderIndex {\n    width: 5.2rem;\n    line-height: 1.6rem;\n}\n\n.codeFrameTextHeaderText {\n    line-height: 1.6rem;\n    white-space: nowrap;\n}\n\n.codeFrameBinaryHeader,\n.codeFrameTraceHeaders {\n    width: 100%;\n}\n\n.choiceGroupHeaders {\n    display: grid;\n    grid-template-columns: 33% auto 33% auto 33%;\n}\n\n/* stylelint-disable selector-class-pattern -- класс Consta */\n.codeFrameBinaryHeader:global(.Table) :global(.Table-ContentCell),\n.codeFrameTraceHeaders:global(.Table) :global(.Table-ContentCell) {\n    font-size: var(--size-text-xs);\n    line-height: var(--line-height-text-l);\n}\n/* stylelint-enable selector-class-pattern */\n\n/* stylelint-disable-next-line selector-class-pattern -- класс Consta */\n.codeFrameTextHeader :global(.Table-ContentCell) {\n    line-height: var(--line-height-text-l);\n}\n\n.radioLabel {\n    padding-bottom: 0.8rem;\n}\n\n/* stylelint-disable-next-line selector-class-pattern -- класс Consta */\n.radioLabel :global(.Radio-Label) {\n    font-size: var(--size-text-s);\n}\n\n/* stylelint-disable-next-line selector-class-pattern -- класс Consta */\n.checkboxLabel :global(.Checkbox-Label) {\n    font-size: var(--size-text-s);\n}\n\n.fullWidth {\n    width: 100%;\n}\n\n.halfWidth {\n    width: 50%;\n}\n\n.containerFields {\n    display: flex;\n    justify-content: flex-end;\n    width: 100%;\n}\n\n.flexedColumn {\n    display: flex;\n    flex-direction: column;\n}\n\n.codeBinaryHeaderTable {\n    flex-direction: column;\n    flex-grow: 1;\n}\n\n.typeChoiceContainer {\n    display: flex;\n    padding-top: 3.2rem;\n}\n\n.typeChoiceWrapper {\n    padding-right: 1.6rem;\n}\n\n.textPadding {\n    padding-bottom: 0.8rem;\n}\n\n.checkboxWrapper {\n    display: flex;\n    flex-direction: column;\n    margin-top: 3.2rem;\n}\n\n.ignoreSegy {\n    padding-bottom: 0.8rem;\n}\n\n.ignoreZeros {\n    padding-bottom: 2.4rem;\n}\n\n.coordinatesWrapper {\n    display: flex;\n}\n\n.coordinatesLabel {\n    margin-bottom: 1.6rem;\n    padding-right: 0.8rem;\n}\n\n.coordinatesBtn {\n    margin-right: 0.8rem;\n}\n\n.coordinatesList {\n    display: flex;\n    flex-direction: column;\n}\n\n.coordinatesNameText {\n    padding-right: 1.2rem;\n}\n\n.formatText {\n    margin-top: 2.8rem;\n    margin-bottom: 0.8rem;\n}\n\n.formatSelect {\n    padding-bottom: 2.4rem;\n}\n\n.optionsWrapper {\n    display: flex;\n    flex-direction: column;\n}\n\n.importWrapper {\n    flex-grow: 1;\n    padding-left: 1.2rem;\n}\n\n.importText {\n    padding-bottom: 0.8rem;\n}\n\n.optionsContainer {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n\n    width: 100%;\n    padding-bottom: 0.8rem;\n}\n\n.optionIcon {\n    margin-right: 0.8rem;\n}\n\n.optionsLabel {\n    padding-right: 0.8rem;\n}\n\n.codeFrameTextWrapper {\n    display: flex;\n    gap: var(--space-xs);\n    align-items: center;\n}\n\n.coordinatesPadding {\n    padding-bottom: 0.8rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"optionsContainerFields": `Setup__optionsContainerFields___tmg8t`,
	"containerFieldsPadding": `Setup__containerFieldsPadding___EOlKi`,
	"coordinatesCombobox": `Setup__coordinatesCombobox___c7rgP`,
	"containerFields": `Setup__containerFields___Mmbom`,
	"coordinatesSelect": `Setup__coordinatesSelect___ZZnOo`,
	"optionsContainer": `Setup__optionsContainer___OU_c2`,
	"optionsFormField": `Setup__optionsFormField___AKJE6`,
	"setupScroll": `Setup__setupScroll___aUWBR`,
	"headerMargin": `Setup__headerMargin___L9SgD`,
	"surveyWrapper": `Setup__surveyWrapper___Jvlgh`,
	"setupDirection": `Setup__setupDirection___aWnuZ`,
	"setupAutoScroll": `Setup__setupAutoScroll___QG6vv`,
	"setupWidth": `Setup__setupWidth___J9YY0`,
	"setupPadding": `Setup__setupPadding___K6oDM`,
	"codeFrame": `Setup__codeFrame___qXg8r`,
	"codeFrameTextHeader": `Setup__codeFrameTextHeader___kdnpL`,
	"codeFrameTextHeaderIndex": `Setup__codeFrameTextHeaderIndex___tn7QO`,
	"codeFrameTextHeaderText": `Setup__codeFrameTextHeaderText___Uq0_d`,
	"codeFrameBinaryHeader": `Setup__codeFrameBinaryHeader___rcKSV`,
	"codeFrameTraceHeaders": `Setup__codeFrameTraceHeaders___UTw5y`,
	"choiceGroupHeaders": `Setup__choiceGroupHeaders___HSn1E`,
	"radioLabel": `Setup__radioLabel___s3kqT`,
	"checkboxLabel": `Setup__checkboxLabel___ktVi4`,
	"fullWidth": `Setup__fullWidth___iXyeE`,
	"halfWidth": `Setup__halfWidth___LD9wX`,
	"flexedColumn": `Setup__flexedColumn___uYdHe`,
	"codeBinaryHeaderTable": `Setup__codeBinaryHeaderTable___t5D3Q`,
	"typeChoiceContainer": `Setup__typeChoiceContainer___vBSGP`,
	"typeChoiceWrapper": `Setup__typeChoiceWrapper___Fd2Xs`,
	"textPadding": `Setup__textPadding___kNkjP`,
	"checkboxWrapper": `Setup__checkboxWrapper___DT6u0`,
	"ignoreSegy": `Setup__ignoreSegy____RQeC`,
	"ignoreZeros": `Setup__ignoreZeros___RaJPU`,
	"coordinatesWrapper": `Setup__coordinatesWrapper___eT9jQ`,
	"coordinatesLabel": `Setup__coordinatesLabel___NAlXS`,
	"coordinatesBtn": `Setup__coordinatesBtn___a36Yn`,
	"coordinatesList": `Setup__coordinatesList___xIr3I`,
	"coordinatesNameText": `Setup__coordinatesNameText___E6zbC`,
	"formatText": `Setup__formatText___G2JxL`,
	"formatSelect": `Setup__formatSelect___r25EG`,
	"optionsWrapper": `Setup__optionsWrapper___FVfB7`,
	"importWrapper": `Setup__importWrapper___raIkE`,
	"importText": `Setup__importText___maKFr`,
	"optionIcon": `Setup__optionIcon___D3R_X`,
	"optionsLabel": `Setup__optionsLabel___pmu3P`,
	"codeFrameTextWrapper": `Setup__codeFrameTextWrapper___mCGGB`,
	"coordinatesPadding": `Setup__coordinatesPadding___mAkAk`
};
export default ___CSS_LOADER_EXPORT___;
